import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';

import { AshbyHealthCheckBanner_AshbyFragment } from 'src/generated/mloop-graphql';

import AppWideBanner, { AppWideBannerAction } from '../AppWideBanner';

interface Fragments {
  ashby: AshbyHealthCheckBanner_AshbyFragment;
}

interface Props {
  retry: AppWideBannerAction;
}

const AshbyHealthCheckBanner: FCWithFragments<Fragments, Props> = ({ ashby, retry }) => {
  const { t } = useTranslation();
  // hide if its not installed or is healthy
  if (!ashby || !ashby?.isInstalled || ashby?.isHealthy) {
    return null;
  }

  return (
    <AppWideBanner
      color="foreground"
      backgroundColor="error"
      text={t('hiring-dashboard-nav:nav.banner.integrationUnhealthy', { integrationName: 'Ashby' })}
      action={retry}
    />
  );
};

AshbyHealthCheckBanner.fragments = {
  ashby: gql`
    fragment AshbyHealthCheckBanner_ashby on AshbyIntegrationHealth {
      isHealthy
      isInstalled
    }
  `,
};

export default AshbyHealthCheckBanner;
